<template>
  <div class="space-y-4">
    <div class="flex justify-between text-base font-medium">
      <p class="text-cream-100 font-sans">{{ t('cart.subtotal') }}</p>
      <p class="text-xl font-mono font-bold text-gold-400">${{ subtotal.toFixed(2) }}</p>
    </div>

    <div v-if="discountAmount > 0" class="flex justify-between text-base font-medium">
      <p class="text-cream-100 font-sans">{{ t('cart.coupon.discount') }}</p>
      <p class="text-base font-mono font-bold text-success-600">- ${{ discountAmount.toFixed(2) }}</p>
    </div>

    <div class="flex justify-between text-base font-medium border-t border-noir-700 pt-3">
      <p class="text-cream-100 font-sans">{{ t('cart.coupon.totalAfterDiscount') }}</p>
      <p class="text-xl font-mono font-bold text-gold-400">${{ total.toFixed(2) }}</p>
    </div>

    <p class="mt-0.5 text-sm text-noir-400 font-sans">{{ t('cart.shippingTaxesInfo') }}</p>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

withDefaults(defineProps<{
  subtotal: number;
  discountAmount?: number;
  total: number;
}>(), {
  discountAmount: 0,
});

const { t } = useI18n();
</script>
